import styled from "styled-components";
import { theme } from "@/styles/theme";
import { TEcoSystemGuide } from "@/typings/Props";
import { media } from "@/styles/media";

export default function EcoSystemModal({
  props,
  isOpen,
  onClose,
}: {
  props: TEcoSystemGuide;
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <EcoSystemModalWrap $isOpen={isOpen} onClick={onClose}>
      <ModalContent>
        <TipClose></TipClose>
        <Title>{props.title}</Title>
        <Desc>{props.desc}</Desc>
      </ModalContent>
    </EcoSystemModalWrap>
  );
}

const EcoSystemModalWrap = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  display: none;
  top: 75px;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  z-index: 1;
  background: ${theme.colors.background.white};
  ${(props) => media.tabletNarrow`
    display: ${props.$isOpen ? "flex" : "none"};
  `}
`;
const ModalContent = styled.div`
  position: relative;
  width: 60%;
  height: 35%;
  margin: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.p`
  margin-bottom: 7px;
  font-size: 1.5rem;
  text-align: center;
  color: ${theme.colors.primary};
`;
const Desc = styled.p`
  font-size: 0.9rem;
  text-align: center;
  line-height: 150%;
  color: ${theme.colors.text.grayLight};
`;
const TipClose = styled.div`
  position: absolute;
  top: -30px;
  left: 50%;
  width: 22px;
  height: 22px;
  margin-left: -11px;
  line-height: 22px;
  border: 2px solid ${theme.colors.primary};
  border-radius: 100px;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 4px;
    width: 10px;
    height: 2px;
    display: block;
    transform: rotate(-45deg);
    background-color: ${theme.colors.primary};
  }

  &::after {
    content: "";
    position: absolute;
    top: 4px;
    left: 8px;
    width: 2px;
    height: 10px;
    display: block;
    transform: rotate(-45deg);
    background-color: ${theme.colors.primary};
  }
`;
